module.exports = __webpack_public_path__ + "img/cb6ee87dadd97fb1b16f54d41120a668.png";